import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Grid, Typography } from '@mui/material';
import { RadioListItem } from 'components/Input/Radio';
import { FnAxios, FnDialog, I18n } from 'utilities/utilities';
import { TextBoxItem } from 'components/Input/TextBox';
import { GetMenuPermission } from 'utilities/SystemFunction';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { BtnBack, BtnRemark, BtnSave } from 'components/Button/ButtonAll';
import { useLocation, useNavigate } from 'react-router';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import { TextAreaItem } from 'components/Input/TextArea';
import moment from 'moment';
import { AutoCompleteItem } from 'components/Input/AutoComplete';
const EquipmentReturnForm = () => {

    const location = useLocation();
    const searchParams = location.search;
    const sID = new URLSearchParams(searchParams).get('sID');
    const navigate = useNavigate();
    const onBack = () => navigate("/EquipmentList?sMode=" + sMode);
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [isOpen, setisOpen] = useState<boolean>(false);
    const [sOrder, setsOrder] = useState("");
    const [nReceiveType, setReceiveType] = useState(0);
    const sMode = new URLSearchParams(searchParams).get("sMode");
    const [loadingTable, setLoadingTable] = useState(false);
    const [arrOrder, setarrOrder] = useState<any>([]);

    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
    });

    const [isPermission, setPermission] = useState<boolean>(false); // Permission
    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const dataColumn: any = [
        {
            field: "nOrder",
            headerName: "ที่",
            headerAlign: "center",
            align: "center",
            resizable: false,
            sortable: false,
            width: 50,
            disableColumnMenu: true,
        },
        {
            field: "sEquipment",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 1,
            width: 200,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        รายการ
                        <span style={{ color: "red" }}> * </span>
                    </Typography>
                )
            },
        },
        {
            field: "sUnit",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 150,
            disableColumnMenu: true,
            renderHeader: (item) => {
                return (
                    <Typography color={"#ffff"} fontSize={14}>
                        หน่วยนับ
                        <span style={{ color: "red" }}> * </span>
                    </Typography>

                )
            },
        },
        {
            field: "sRemark",
            headerName: "หมายเหตุ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 120,

            disableColumnMenu: true,
            renderCell: (item) => {
                return (
                    <>
                        <BtnRemark
                            id={"btn" + item.row.sID}
                            IsCircleWithOutText
                            className='btnicon-remark'
                            onClick={() => onOpenModal(item.row.sID, item.row.sRemark, item.row.sDetail)}
                        />

                    </>
                );
            },
        },

    ];

    //ค้นหาOrder
    const onGetOrder = (nReceiverID, nUserID) => {
        let param = {
            nReceiverID: nReceiverID,
            nUserID: nUserID
        };
        AxiosFn.Post(`Equipment/GetOrderWithdrawEquipment`, param, (result) => {
            setarrOrder(result.lstEquipmentWithdrawOrder);
        })
    }

    // ดึงรายการที่ยืม
    const onGetEquipment = (nWithdrawID) => {
        let param = {
            nWithdrawID: nWithdrawID
        };
        AxiosFn.Post(`Equipment/GetWithdrawEquipmentOrder`, param, (result) => {
            setDataRow({
                ...dataRow,
                arrRows: result.lstDataWithdraw
            });

            form.setValue(`sExternalReturnBy`, result.sExternalReceiver);
            form.setValue(`nReturnByUserID`, result.objReceiverID);
            form.setValue("nReturnUnitType", result.nReceiverUnitType + "");
            setReceiveType(result.nReceiverUnitType);
        })

    }

    //บันทึกหมายเหตุ
    const onOpenModal = (sIDRow, sRemark, sDetail) => {
        setisOpen(true);
        setsOrder(sIDRow);
        form.setValue("sRemark", sRemark);
        form.setValue("sDetail", sDetail);


    };
    const onSummitRemark = () => {
        setisOpen(false);
        let sDetailform = form.getValues(`sDetail`);
        let sRemarkform = form.getValues(`sRemark`);

        let arrClone = dataRow;
        if (arrClone.arrRows.length > 0) {
            arrClone.arrRows.forEach((f) => {
                f.sDetail = f.sID == sOrder ? sDetailform : f.sDetail;
                f.sRemark = f.sID == sOrder ? sRemarkform : f.sRemark;
            });
        }
        setDataRow({ ...arrClone });
    }

    //ลบข้อมูลในตาราง
    const handleDelete = (arrID) => {
        DialogFn.Submit(`${I18n.SetText("Material.sConfirmDel")}`, () => {
            let arrClone = dataRow;
            arrClone.arrRows = arrClone.arrRows.filter((f) => !arrID.includes(f.sID));
            // เรียง Order ใหม่
            if (arrClone.arrRows.length > 0) {
                let nOrder = 1;
                arrClone.arrRows.forEach((f) => {
                    f.nOrder = nOrder;
                    nOrder++;
                });
            }
            setDataRow({ ...arrClone });
            DialogFn.Success("ลบข้อมูลสำเร็จ");
        });
    };

    // บันทึก
    const onSubmit = (e) => {
        let lstDataType = []
        let lstData = []
        lstData = dataRow.arrRows;
        lstData.forEach((item) => {
            lstDataType.push({
                sID: item.sID,
                nOrder: item.nOrder,
                nEquipmentID: item.nEquipmentID,
                sUnit: item.sUnit,
                sRemark: form.getValues("sRemark") ? form.getValues("sRemark") : item.sRemark,
                nWithdrawItemID: item.nWithdrawItemID,
                nWithdrawID: item.nWithdrawID,
                sHolderName: item.sHolderName,
                sEquipment: item.sEquipment,
                nHolderID: item.nHolderID,
                nReturnItemID: item.nReturnItemID,
            })
        })
        let param = {
            sID: sID ? sID : "",
            nWithdrawID: form.getValues("nWithdrawID"),
            nReturnUnitType: +form.getValues("nReturnUnitType"),
            nReturnByUserID: form.getValues("nReturnByUserID") ? form.getValues("nReturnByUserID").value : null,
            sExternalReturnBy: form.getValues("sExternalReturnBy") ? form.getValues("sExternalReturnBy") : "",
            nReturnDate: form.getValues("dReturn").valueOf(),
            lstDataWithdraw: lstDataType,
        };

        DialogFn.Submit("คุณต้องการบันทึก ใช่หรือไม่", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(`Equipment/SaveReturnEquipment`, param, (result) => {
                DialogFn.UnBlockUI();
                DialogFn.Success(`บันทึกสำเร็จ`);
                DialogFn.CloseSubmit()
                navigate("/EquipmentList?sMode=" + sMode);
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    //ดึงข้อมูลมาแก้ไข
    const getReceiveMaterialEdit = (p: PaginationInterface) => {
        setLoadingTable(true);
        let Param = {
            ...p,
            sID: sID ? sID : ""
        };
        DialogFn.BlockUI();
        AxiosFn.Post(`Equipment/GetReturnEquipmentEdit`, Param, (result) => {
            DialogFn.UnBlockUI();
            setLoadingTable(false);
            if (sID) {
                setDataRow({
                    ...p,
                    arrRows: [...result.lstDataWithdraw],
                    nDataLength: result.ObjTable?.nDataLength,
                    nPageIndex: result.ObjTable?.nPageIndex,
                });
                setTimeout(() => {
                    (result.lstDataWithdraw ?? []).forEach(f => {
                        f.nOrder = f.nOrder;
                        form.setValue(`sRemark`, f.sRemark);
                    })

                }, 300);
                setarrOrder(result.lstEquipmentOrder);
                form.setValue(`nWithdrawID`, result.nWithdrawID);
                form.setValue(`nReceiverID`, result.objReceiverID);
                form.setValue("nReturnUnitType", result.nReturnUnitType + "");
                form.setValue(`nReturnByUserID`, result.objReturnByUserID);
                form.setValue(`sExternalReturnBy`, result.sExternalReturnBy);
                form.setValue("dReturn", moment(result.nReturnDate));
                setReceiveType(result.nReturnUnitType);
            }

        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        }
        );
    };

    useEffect(() => {
        getReceiveMaterialEdit(dataRow);
    }, []);

    return (
        <React.Fragment>
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <AutoCompleteItem
                            id={`nReceiverID`}
                            name={`nReceiverID`}
                            sUrlAPI={`Equipment/GetSearchEquipmentWithdraw`}
                            label="ผู้ขอยืม"
                            placeholder="ผู้ขอยืม"
                            required={true}
                            disabled={!isPermission || sID != null}
                            onChange={(e) => {
                                onGetOrder(e ? e.value : null, e ? e.nUserID :null)
                            }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={4}></Grid>
                    <Grid item container xs={12} md={6}>
                        <SelectItem
                            id="nWithdrawID"
                            name={"nWithdrawID"}
                            label={"เลือกรายการยืม"}
                            placeholder={"เลือกรายการยืม"}
                            options={arrOrder}
                            required={true}
                            disabled={!isPermission || sID != null}
                            onChange={(e) => {
                                onGetEquipment(e ? e.value : null)
                            }}
                        />
                    </Grid>

                    <Grid item container xs={12} md={12}>
                        <Grid item container xs={12} md={3} sx={{ marginBottom: "10px" }} >
                            <RadioListItem
                                id={"nReturnUnitType"}
                                name={"nReturnUnitType"}
                                required={true}
                                options={[
                                    { value: "1", label: `${I18n.SetText("Material.sFossilManagement")}` },
                                    { value: "2", label: `${I18n.SetText("Material.sExternal")}` },
                                ]}
                                onChange={(e) => {
                                    setReceiveType(e ? e : null)
                                    form.setValue(`nReturnByUserID
                                    `, null);
                                }}

                                disabled={!isPermission}
                                label="หน่วยงานคืน"
                            />
                        </Grid>

                        <Grid item container xs={12} md={6} sx={{ marginTop: "17px" }} >
                            <Grid item xs={12} md={8} >
                                {nReceiveType == 1 &&
                                    <AutoCompleteItem
                                        id={`nReturnByUserID`}
                                        name={`nReturnByUserID`}
                                        sUrlAPI={`MaterialInventory/GetSearchUser`}
                                        label="ผู้คืน"
                                        required={nReceiveType == 1}
                                        disabled={!isPermission}
                                        fullWidth
                                    />
                                }
                            </Grid>
                            <Grid item container xs={12} md={12} sx={{ marginTop: "17px" }} >
                                {nReceiveType == 2 &&
                                    <Grid item xs={12} md={12}>
                                        <TextBoxItem
                                            required={nReceiveType == 2}
                                            label="หน่วยงาน"
                                            id={'sExternalReturnBy'}
                                            name={'sExternalReturnBy'}
                                            maxLength={250}
                                            type={'text'}
                                            IsShowMessageError
                                            disabled={!isPermission}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <DatePickerItem
                            required={true}
                            name={"dReturn"}
                            id={"dReturn"}
                            label="วันที่คืน"
                            fullWidth
                            disabled={!isPermission}
                            maxDate={moment()}
                        />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <DataGrid
                            columns={dataColumn}
                            rows={dataRow}
                            isDisableColumnMenu={true}
                            onDelete={handleDelete}
                            isHiddenToolHead
                            isHiddenPagination
                            isShowCheckBox={isPermission || sID == null}
                            onRowSelectable={(p) => sID == null}
                            isLoading={loadingTable}
                        />
                    </Grid>

                </Grid>
                <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
                    <Grid item xs={6} md={6}>
                        <BtnBack id={"btnBack"} onClick={() => onBack()} />
                    </Grid>

                    <Grid container item xs={6} md={6} justifyContent="flex-end">
                        <BtnSave
                            IsDisabled={!isPermission}
                            id={"btnSave"}
                            onClick={form.handleSubmit(
                                (e) => onSubmit(e),
                                (err) => console.log("err", err)
                            )}
                        />
                    </Grid>
                </Grid>

                <DialogPreview
                    IsOpen={isOpen}
                    IsBackdropClick={false}
                    onClose={() => { setisOpen(false); }}
                    JsxDialogAction
                    CloseSave={sID == null ? true : false}
                    onClick={() => { onSummitRemark(); }}
                    Close={true}
                    sMaxWidth='sm'
                    bgColor={"#a07300"}
                    Color='white'
                    Title={''}
                >
                    <Grid container justifyContent={"center"} >
                        {sMode == "Withdraw" &&
                            <Grid item xs={12} md={12}>
                                <TextAreaItem
                                    placeholder=""
                                    label='รายละเอียดเพิ่มเติม (จ่ายให้)'
                                    name={`sDetail`}
                                    maxLength={500}
                                    id={`sDetail`}
                                    required={false}
                                    disabled={!isPermission || sID != null}
                                />
                            </Grid>
                        }
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                placeholder=""
                                label='หมายเหตุ'
                                name={`sRemark`}
                                maxLength={500}
                                id={`sRemark`}
                                required={false}
                                disabled={!isPermission || sID != null}
                            />
                        </Grid>
                    </Grid>
                </DialogPreview >
            </FormProvider>
        </React.Fragment >
    );
}
export default EquipmentReturnForm;



